import clsx from 'clsx';

export interface SkeletonProps {
  /** Extra tailwind classes (width, height, rounded radius, margin). */
  className?: string;
  /** Optional aria-label for screen readers. Defaults to "Cargando". */
  ariaLabel?: string;
}

/**
 * Sealed visual primitive: a slate-200 pulsing block used as a placeholder
 * while a remote resource is loading. Mirrors the rounded-lg/card geometry
 * that already dominates the design DNA so it slots in without restyling.
 *
 * Kept intentionally minimal — callers compose multiples to mimic the shape
 * of the upcoming content (cards, lines, badges).
 */
export function Skeleton({ className, ariaLabel = 'Cargando' }: SkeletonProps): JSX.Element {
  return (
    <div
      role="status"
      aria-label={ariaLabel}
      className={clsx('animate-pulse rounded bg-slate-200', className)}
    />
  );
}
